import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import NiceModal from "@ebay/nice-modal-react";
import StatementEdition from "../StatementEdition/StatementEdition";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import './AreaBlockStatement.css';
import useShowRawInformation from "/src/features/editor/hook/useShowRawInformation";
import { useState } from "react";
import * as purify from "dompurify";
import storage from '/src/utils/storage';
function AreaBlockStatement(props) {
    const company = storage('session').get('company');
    var className = "bubble";

    if (props.idx == 0) {
        className += " start";
    }

    if (props.idx == -1) {
        className += " end";
    }
    const classNameAvatar = props.first == true ? 'pad avatar' : 'pad';

    const regex = /\[(.*?)\]/gi;
    const content = props.content.replaceAll(regex, function (match) {
        return "<mark>" + match + "</mark>"
    });

    const editStatement = async (e) => {
        const result = await NiceModal.show('editor-popup', { Component: StatementEdition, componentProps: { content: props.content, index: props.first == true ? 0 : props.idx, type: props.type } });
        const { data, index } = result;
        props.setValue(index, data)
    }

    const [isHover, setIsHover] = useState(false);
    return (
        <div className="area-block-statement" onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
            <div className={classNameAvatar} style={props.first == true && company?.logo ? { backgroundImage: `url(${company.logo})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}></div>
            {props.type == 'text' ? <span className={className} dangerouslySetInnerHTML={{ __html: purify.sanitize(content, { sanitize: true }) }}></span> : ''}
            {props.type == 'raw' ? useShowRawInformation('statement', {}, className, 'Raw Message') : ''}
            <div className="actions">
                {
                    (isHover && props.idx != 0 && props.first != true) && <IconButton onClick={() => props.move(props.idx, -1)} className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-chevron-up" />
                }
                {
                    (isHover && props.idx != - 1) && <IconButton onClick={() => props.move(props.idx, 1)} className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-chevron-down" />
                }

                <IconButton className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-edit" onClick={editStatement}></IconButton>
                <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={() => props.deleteValue(props.first == true ? 0 : props.idx)}></IconButton>
            </div>
        </div>
    )
}

export default AreaBlockStatement;